<template>
  <ModalDialog
    ref="dialog"
    :title="title"
    :submitting="submitting"
    :submitTitle="submitTitle"
    icon="fa-calendar"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="dialogForm" :labelColumnSize="3">
      <FormRow label="Name"><FormInputText placeholder="Name" v-model="calendarEvent.name" field="name" /></FormRow>
      <FormRow label="Type"><FormSelect placeholder="Type" v-model="calendarEvent.type" :options="CalendarEventTypeLookup" field="type" /></FormRow>
      <FormRow label="Start Date">
        <FormDate v-model="calendarEvent.startDate" field="startDate" />
      </FormRow>
      <FormRow label="End Date"><FormDate v-model="calendarEvent.endDate" field="endDate" /></FormRow>
      <FormRow label="Production" helpTip="If set, the calendar event applies to production"><FormCheckbox v-model="calendarEvent.isProductionEvent" field="isProductionEvent" /></FormRow>
      <FormRow label="Task" helpTip="If set, the calendar event applies to tasks"><FormCheckbox v-model="calendarEvent.isTaskEvent" field="isTaskEvent" /></FormRow>      
    </FormGroup>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'

import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import ModalDialogMixin from '@/mixins/modalDialog'

import { CalendarEventTypeLookup } from '@/store/types'

export default {
  name: 'CalendarEventEditDialog',
  mixins: [
    ModalDialogMixin,
    form
  ],
  components: {
    ModalDialog
  },
  props: {
    isCreateMode: Boolean
  },
  data() {
    return {
      calendarEventId: null,
      calendarEvent: {
      },
      dialogForm: {},
      submitting: false
    }
  },
  created() {
    this.CalendarEventTypeLookup = CalendarEventTypeLookup
  },
  mounted() {
  },
  computed: {
    title() {
      return this.isCreateMode ? 'New Calendar Event' : 'Edit Calendar Event'
    },
    submitTitle() {
      return this.isCreateMode ? 'Create' : 'Update'
    },
  },
  methods: {
    show(calendarEvent) {
      // Reset form
      this.calendarEvent = {
      }
      this.calendarEventId = 0
      this.dialogForm = {}
      this.submitting = false

      if(calendarEvent != null) {
        this.calendarEvent = _.cloneDeep(calendarEvent)
        this.calendarEventId = calendarEvent.id
      }

      return ModalDialogMixin.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(false)
    },
    onSubmitted() {
      this.submitting = true

      var updateData = _.cloneDeep(this.$data.calendarEvent)

      if(this.isCreateMode) {
        this.$apiService.adminService.createCalendarEvent(updateData)
        .then(() => {
          this.submitting = false
          this.modalClosed(true)
          this.hide()
        })
        .catch(err => {
          this.submitting = false
          this.$data.dialogForm = this.processFormResponse(err)
        })
      } else {
        this.$apiService.adminService.updateCalendarEvent(this.calendarEventId, updateData)
        .then(() => {
          this.submitting = false
          this.modalClosed(true)
          this.hide()
        })
        .catch(err => {
          this.submitting = false
          this.$data.dialogForm = this.processFormResponse(err)
        })
      }
    }
  }
}
</script>